import { startCase, get } from 'lodash';

export type TripTypeKey = 'single' | 'annual' | string;

export const standardiseTheName = (name: string) => startCase(String(name || '').replace('_', ' '));

export const parseDob = (dobStr: string): Date | null => {
    if (!dobStr) { return null; }
    const [dd, mm, yyyy] = dobStr.split('/').map(Number);
    if (!dd || !mm || !yyyy) { return null; }
    return new Date(yyyy, mm - 1, dd);
};

export const getAge = (dob: Date, today = new Date()): number => {
    let age = today.getFullYear() - dob.getFullYear();
    const m = today.getMonth() - dob.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) { age--; }
    return age;
};

export const isQuoteUnavailable = (q: any): boolean => {
    if (!q) { return true; }
    const hasError = q.errors && q.errors.length > 0;
    const hasDeclines = q.declines && q.declines.length > 0;
    const hasReferrals = q.referrals && q.referrals.length > 0;
    return !!(hasError || hasDeclines || hasReferrals);
};

export const isQuoteOkForDisplay = (q: any): boolean => {
    if (!q) { return false; }
    const hasError = q.errors && q.errors.length > 0;
    const hasDeclines = q.declines && q.declines.length > 0;
    const hasReferrals = q.referrals && q.referrals.length > 0;
    return !(hasError || hasDeclines || hasReferrals);
};

export const parseUkDate = (dateStr: string): Date | null => {
    return parseDob(dateStr);
};

export const shouldShowAnnualTile = (quote: any, maxTripDuration: string): boolean => {
    const startDateStr = get(quote, 'application.startDate');
    const endDateStr = get(quote, 'application.endDate');

    const startDate = parseUkDate(startDateStr);
    const endDate = parseUkDate(endDateStr);

    if (!startDate || !endDate) { return true; }

    const diffInMs = endDate.getTime() - startDate.getTime();
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

    return diffInDays <= Number(maxTripDuration);
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/SchemeChoiceB/schemeChoice.rules.ts